<template>
  <div
    class="flex-1 p-4 sm:p-6 flex items-center justify-center rounded-b min-h-48"
    :class="[result && result.error && 'bg-red-100']"
  >
    <div v-if="sending">
      <Loader />
    </div>
    <div v-else-if="result.error">
      <h2 class="text-center text-lg font-medium text-red-800">Sending failed.</h2>
      <p class="mt-4 text-center text-sm text-red-800">
        {{ result.error }}
      </p>
    </div>
  </div>
</template>

<script>
import { contactSentEmailMessagesClient } from '@/api/clients';

export default {
  props: {
    contactId: {
      type: String,
      required: true,
    },
    emailMessageId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      result: null,
      sending: false,
    };
  },
  created() {
    this.sendEmail();
  },
  methods: {
    async sendEmail() {
      try {
        this.sending = true;

        const response = await contactSentEmailMessagesClient.store(this.contactId, {
          email_message_id: this.emailMessageId,
        });

        this.result = response.data;

        if (!response.data.error) {
          this.$emit('sent');
        }
      } catch (error) {
        this.result = {
          status: 'error',
          error: error.message,
        };
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>
